module.exports = __webpack_public_path__ + "static/media/star-wars-1.6c919353.png";